import { useEffect, useState } from "react";
import { CONFIG } from "../config/general";

const FileMessage = ({ file }) => {
  const [localFilePath, setLocalFilePath] = useState(null);
  const fileName = file.url;
  const fileUrl = CONFIG.REACT_APP_ENDPOINT + "/uploads/chat/" + file.url;
  const fileExtension = file.url?.split(".").pop().toLowerCase();
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp"];
  const videoExtensions = ["mp4", "avi", "mov", "webm"];
  const Icons = {
    // 📄 Document Files
    "pdf": "./assets/images/pdf.svg",
    "doc": "./assets/images/word.svg",
    "docx": "./assets/images/word.svg",
    "xls": "./assets/images/excel.svg",
    "xlsx": "./assets/images/excel.svg",
    "ppt": "./assets/images/powerpoint.svg",
    "pptx": "./assets/images/powerpoint.svg",
    "txt": "./assets/images/text.svg",
    "csv": "./assets/images/csv.svg",
    "rtf": "./assets/images/rtf.svg",

    // 🖼️ Image Files
    "jpg": "./assets/images/image.svg",
    "jpeg": "./assets/images/image.svg",
    "png": "./assets/images/image.svg",
    "gif": "./assets/images/image.svg",
    "bmp": "./assets/images/image.svg",
    "webp": "./assets/images/image.svg",
    "svg": "./assets/images/image.svg",
    "ico": "./assets/images/image.svg",

    // 🎥 Video Files
    "mp4": "./assets/images/video.svg",
    "avi": "./assets/images/video.svg",
    "mov": "./assets/images/video.svg",
    "mkv": "./assets/images/video.svg",
    "webm": "./assets/images/video.svg",
    "flv": "./assets/images/video.svg",
    "wmv": "./assets/images/video.svg",

    // 🎵 Audio Files
    "mp3": "./assets/images/audio.svg",
    "wav": "./assets/images/audio.svg",
    "flac": "./assets/images/audio.svg",
    "aac": "./assets/images/audio.svg",
    "ogg": "./assets/images/audio.svg",
    "wma": "./assets/images/audio.svg",

    // 🗄️ Archive Files
    "zip": "./assets/images/zip.svg",
    "rar": "./assets/images/zip.svg",
    "tar": "./assets/images/zip.svg",
    "gz": "./assets/images/zip.svg",
    "7z": "./assets/images/zip.svg",

    // 🔣 Code Files
    "js": "./assets/images/code.svg",
    "jsx": "./assets/images/code.svg",
    "ts": "./assets/images/code.svg",
    "tsx": "./assets/images/code.svg",
    "html": "./assets/images/code.svg",
    "css": "./assets/images/code.svg",
    "scss": "./assets/images/code.svg",
    "php": "./assets/images/code.svg",
    "py": "./assets/images/code.svg",
    "java": "./assets/images/code.svg",
    "c": "./assets/images/code.svg",
    "cpp": "./assets/images/code.svg",
    "cs": "./assets/images/code.svg",
    "json": "./assets/images/json.svg",
    "xml": "./assets/images/xml.svg",

    // 📦 Executable Files
    "exe": "./assets/images/exe.svg",
    "apk": "./assets/images/apk.svg",
    "dmg": "./assets/images/dmg.svg",

    // 🔖 Default Icon
    "default": "./assets/images/default.svg"
  };

  const audioExtensions = ["mp3", "wav", "ogg", "webm"]; // note: webm can be both

  useEffect(() => {
    setLocalFilePath(fileUrl);
    // eslint-disable-next-line
  }, [fileName]);

  const handleOpenFile = (filePath) => {
    window.open(filePath, "_blank");
  };

  const getFileIcon = (extension) => Icons[extension] || Icons["default"];

  return (
    <div className="file-message" style={{ paddingBlockStart: "10px" }}>
      {imageExtensions.includes(fileExtension) ? (
        <img
          src={localFilePath}
          alt="Preview"
          style={{ maxWidth: "150px", cursor: "pointer" }}
          className="file-preview"
          onClick={() => handleOpenFile(localFilePath)}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = fileUrl;
          }}
        />
      ) : videoExtensions.includes(fileExtension) && !audioExtensions.includes(fileExtension) ? (
        <video
          src={localFilePath}
          controls
          style={{ width: "100%" }}
          className="file-preview"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = fileUrl;
          }}
        />
      ) : audioExtensions.includes(fileExtension) ? (
        <audio
          src={localFilePath}
          controls
          className="audio-preview"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = fileUrl;
          }}
        />
      ) : (
        <img
          src={getFileIcon(fileExtension)}
          onClick={() => handleOpenFile(localFilePath)}
          style={{ maxWidth: "150px", cursor: "pointer" }}
          alt="Preview"
          className="file-preview"
        />
      )}

      <p style={{ cursor: "pointer", placeSelf: "end" }} onClick={() => handleOpenFile(localFilePath)}>
        {fileName}
      </p>
    </div>
  );
};

export default FileMessage;
